exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn {\n  background-color: #74b856ff;\n  color: #fff;\n  font-family: 'Roboto Slab';\n  font-weight: 100;\n  text-transform: uppercase;\n  -webkit-box-shadow: 0 5px 15px rgba(145,92,182,.2);\n          box-shadow: 0 5px 15px rgba(145,92,182,.2);\n}\n\n.btn:hover {\n  background-color: #74b856ff;\n  -webkit-box-shadow: 0 5px 15px rgba(145,92,182,.4);\n          box-shadow: 0 5px 15px rgba(145,92,182,.4);\n}\n\nh2 {\n  font-family: 'Roboto Slab', sans-serif;\n  color: #ffab40;\n  font-weight: lighter;\n  margin-bottom: 20px;\n}\n\n.form-control {\n  overflow-y: show;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Food-Savor/src/app/modal/modal.component.css
// module id = ../../../../../src/app/modal/modal.component.css
// module chunks = main